import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket, faMountainSun } from '@fortawesome/free-solid-svg-icons';

import { auth, logout, getData } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import { CHECKLSIT, CHECKLSIT_START} from "../../constants/checkList"
import { IMAGES } from "../../constants/index"
import { CAMPAIGN_DATE } from "../../constants/constants"


import './MyFaithPage.css';


function MyFaithPage(){
    let navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [data,setData] = useState(null)
    const [checkList,setCheckList] = useState(null)
    const [opacity, setOpacity] = useState(0);
    const [dayIndex,setDayIndex] = useState(null)
    const [myFaith,setMyFaith] = useState([])
    const [step,setStep] = useState({})
    const [backValidate,setBackValidate] = useState(false)
    

    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        if(user){
            getUserData()
        }
    }, [user]);

    useEffect(() => {
        if(checkList){
            myFaithData()
        }
    }, [checkList]);

    useEffect(() => {
        if(myFaith,step){
            setTimeout(() => {
                setOpacity(1);
            }, 500); // 0.5초 후 페이드 인
        }
    }, [myFaith, step]);

    useEffect(() => {
        if(dayIndex!=null&&data!=null){
            validateDate(data.lastestUpdateDate)
        }
    }, [dayIndex,data]);


    const getUserData = async () => {
        const data = await getData(user.uid)
        setData(data[0])
        setCheckList(data[0].checkList)
        setStep(data[0].event)
        setDayIndex(Object.keys(data[0]?.checkList || {}).length);
    }
    const myFaithData = async () => {
        const sortedKeys = Object.keys(checkList).sort((a, b) => {
            // 🔹 "Day1", "Day2" 등의 숫자 부분만 추출
            const numA = parseInt(a.replace(/[^0-9]/g, ""), 10); // ✅ 숫자만 남김
            const numB = parseInt(b.replace(/[^0-9]/g, ""), 10); // ✅ 숫자만 남김
        
            return numA - numB; // 오름차순 정렬
        });
        
        // 🔥 변환된 데이터 생성 (정렬된 순서 유지)
        const result = sortedKeys.map((key) => ({
            name: key,
            myFaith: (Array.isArray(checkList[key]) ? checkList[key] : []).filter((item) => Boolean(item)).length,
        }));
        setMyFaith(result)
    }
    const  validateDate = (updatedDate) => {
        if (!updatedDate) {
            setOpacity(1);
            return false;
        }

        // 🔹 1. 한국 시간(KST) 기준 오늘 날짜 가져오기
        const today = new Date().toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).replace(/. /g, "-").replace(".", ""); // ✅ "2025-02-22" 형식으로 변환
    
        // 🔹 2. updatedDate에서 날짜 부분만 추출 (예: "2025. 02. 22." → "2025-02-22")
        const updatedDateString = data.lastestUpdateDate.split(" ")[0].replace(/. /g, "-").replace(".", "");
        // console.log(today,updatedDateString,CAMPAIGN_DATE[dayIndex],today == updatedDateString,updatedDateString == CAMPAIGN_DATE[dayIndex-1])

        // 🔹 3. 날짜 비교 후 결과 반환
        if (today == updatedDateString && updatedDateString == CAMPAIGN_DATE[dayIndex-1]) {
            setBackValidate(false)
        } else {
            if(dayIndex===4) setBackValidate(false)
            else setBackValidate(true)
        }
    }


    const handleShowRhema = (index) => {
        setOpacity(0); // 🔥 페이드 아웃 시작
        setTimeout(() => {
            navigate(`/myRhema/${index}`);
        }, 2000);
    }
    const handleNextFaith = async() => {
        const isConfirmed = window.confirm("다음 믿음의 도전을 시작할까요?");
        if (isConfirmed) {
            try{
                handleNavigation("/byFaith");
            } catch (e) {
                console.error("로그아웃에 실패했습니다.", e)
            }
        }
    }
    const handleNavigation = (address) => {
        setOpacity(0); // 🔥 페이드 아웃 시작
        setTimeout(() => {
            navigate(address);
        }, 2000);
    }
    const handlelogout = async() => {
        const isConfirmed = window.confirm("로그아웃 하시겠습니까?");
        if (isConfirmed) {
            try{
                const result = await logout()
                navigate('/login');
            } catch (e) {
                console.error("로그아웃에 실패했습니다.", e)
            }
        }
    }


    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="myFaithWrap" style={{ opacity, transition: "opacity 1s ease-in-out" }}>
                <div className="contentsTitle">
                    {/* <span className="iconButton"> */}
                    <span className="iconButton">
                    </span>
                    <span style={{textAlign:'center'}}>
                        <span style={{display:'block', marginBottom:'10px'}}>믿음의 여정</span>
                        <span style={{display:'block',fontSize:'12px',textAlign:'center', opacity:0.5,fontFamily:'GapyeongHanseokbongL'}}>#{data?.id}</span>
                    </span>
                    <span className="iconButton" onClick={handlelogout}>
                        <FontAwesomeIcon className="iconBtn" icon={faRightFromBracket} style={{color:"#131835"}}/>
                    </span>
                </div>
                <div className="contents">
                    {myFaith.map((item,index)=>{
                        return(
                            <div key={index} className="stampBox">
                                <span className="dayTitle">{item.name}</span>
                                <span className="myFaithStamp">
                                    {item.myFaith===(index===0? CHECKLSIT_START.length:CHECKLSIT.length)? <img src={IMAGES.FAITH_SUCCESS}/>:<img src={IMAGES.FAITH}/>}
                                </span>
                                {item.myFaith===(index===0? CHECKLSIT_START.length:CHECKLSIT.length)&&
                                <span className="rhemaButton"  onClick={()=>handleShowRhema(index)}>
                                    <span>말씀 다시보기</span>
                                </span>
                                }
                            </div>
                        )
                    })}
                </div>
                {myFaith?.length<8&&
                <div className="contentsButton">
                    <span onClick={()=>handleNavigation('/faith')}>믿음대로 캠페인이란?</span>
                </div>  
                }  
                {myFaith?.length===8&&
                <div className="contentsButton">
                    <span className="half" onClick={()=>handleNavigation('/faith')}>믿음대로 캠페인이란?</span>
                    {!step.epilogue&&<span className="half" onClick={()=>handleNavigation('/epilogue')}>챌린지 종료하기</span>}
                    {step.epilogue&&<span className="half" onClick={()=>handleNavigation('/note')}>노트</span>}
                </div>  
                }     
            </div>
        </div>
    );
  }
  export default MyFaithPage;